import { render, staticRenderFns } from "./OrderReview.vue?vue&type=template&id=72e671b2&scoped=true&"
import script from "./OrderReview.ts?vue&type=script&lang=ts&"
export * from "./OrderReview.ts?vue&type=script&lang=ts&"
import style0 from "./OrderReview.less?vue&type=style&index=0&id=72e671b2&prod&lang=less&scoped=true&"
import style1 from "./NewCustomer.less?vue&type=style&index=1&id=72e671b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e671b2",
  null
  
)

export default component.exports